import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  OnInit,
  TrackByFunction,
  inject
} from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FeeBasedService } from "@vp/models";
import { Observable } from "rxjs";
import { EditServiceCostModel } from "../edit-service-cost.service";

export interface OverrideServiceFormDialogData {
  feeBasedServices: Observable<FeeBasedService[]>;
  override: EditServiceCostModel;
  mode: "edit" | "create";
}

@Component({
  selector: "vp-add-service-form",
  templateUrl: "./add-service-form.component.html",
  styleUrls: ["./add-service-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AddServiceFormComponent implements OnInit {
  private readonly dialogRef = inject<MatDialogRef<AddServiceFormComponent>>(MatDialogRef);
  data = inject<OverrideServiceFormDialogData>(MAT_DIALOG_DATA);
  private readonly fb = inject(UntypedFormBuilder);

  form!: UntypedFormGroup;
  originalClose;

  constructor() {
    // Add confirm close logic to dialog to centralize
    this.originalClose = this.dialogRef.close;
    this.dialogRef.close = this.confirmClose.bind(this);
  }

  @HostListener("window:keyup.esc") onKeyUp() {
    this.confirmClose({ save: false });
  }

  @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
    event.returnValue = false;
  }

  ngOnInit(): void {
    this.form = this.getForm(this.data.override);
    if (this.data.mode === "edit") {
      this.form.get("friendlyId")?.disable();
    }
  }

  // Satisfies template-use-track-by-function
  trackByFn: TrackByFunction<FeeBasedService> = (_index: number, item: FeeBasedService) =>
    item.friendlyId;

  confirmClose(result: { save?: boolean }) {
    if (result.save && this.form.valid) {
      const formValue = this.form.getRawValue();
      this.originalClose.bind(this.dialogRef)(formValue);
    } else {
      if (this.form.pristine || this.form.invalid) {
        this.originalClose.bind(this.dialogRef)();
      } else {
        if (confirm("Are you sure you want to cancel and potentially lose data?")) {
          this.originalClose.bind(this.dialogRef)();
        }
      }
    }
  }

  private getForm(serviceOverride: EditServiceCostModel) {
    return this.fb.group({
      friendlyId: [serviceOverride.friendlyId],
      active: [serviceOverride.active],
      fee: [serviceOverride.fee]
    });
  }
}
